'use client';

import React, { useMemo } from 'react';

const COLORS = ['#16a34a', '#eab308', '#f59e0b', '#22c55e', '#fde047', '#4ade80'];

export default function ConfettiOverlay() {
  const pieces = useMemo(
    () =>
      Array.from({ length: 40 }, (_, i) => ({
        id: `confetti-${i}`,
        color: COLORS?.[i % COLORS?.length],
        left: (i * 2.5) % 100,
        delay: (i % 10) * 0.1,
        duration: 2.5 + (i % 5) * 0.3,
        size: 6 + (i % 4) * 2,
        rotation: i * 9,
      })),
    []
  );

  return (
    <div className="fixed inset-0 pointer-events-none z-50 overflow-hidden">
      {pieces?.map((p) => (
        <div
          key={p?.id}
          className="absolute top-0 animate-confetti-fall"
          style={{
            left: `${p?.left}%`,
            width: p?.size,
            height: p?.size,
            backgroundColor: p?.color,
            borderRadius: p?.rotation % 2 === 0 ? '50%' : '2px',
            animationDelay: `${p?.delay}s`,
            animationDuration: `${p?.duration}s`,
            transform: `rotate(${p?.rotation}deg)`,
            opacity: 0.9,
          }}
        />
      ))}
    </div>
  );
}